// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1CIvY","clinicsSelect":"TableHeading_clinicsSelect__9pZe6"};